export const TrustSectionsEnum = {
  Home: 'HOME',
  TrustDetails: 'TRUST_DETAILS',
  Subscriber: 'SUBSCRIBER',
  TrustAssetsDetails: 'TRUST_ASSETS_DETAILS',
  Documents: 'DOCUMENTS',
  Forms: 'FORMS',
  Taxes: 'TAXES',
  BondSurety: 'BOND_SURETY',
  Notes: 'NOTES',
  Messages: 'MESSAGES',
} as const;

export type TrustSections =
  (typeof TrustSectionsEnum)[keyof typeof TrustSectionsEnum];
